import "./QuoteCalculator.module.css";
import Header from "@/reusable_sections/Header";
import CalculatorHero from "./sections/CalculatorHero";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function QuoteCalculatorPage() {
  return <div>
      <Header />
      <CalculatorHero />
      <Quote />
      <Footer />
    </div>;
}